import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import MDBox from "../../MDBox";
import PropTypes from "prop-types";
import React, { useCallback } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import WordSearch from "./word-search.js";

function Configurator({ params, onChange }) {
  const words = params.words || [];

  const handleAddWord = (word) => {
    if (!words.includes(word)) {
      onChange({
        ...params,
        words: words.concat([word]),
      });
    }
  };

  const handleDeleteWord = (word) => {
    if (words.includes(word)) {
      onChange({
        ...params,
        words: words.filter((v) => v !== word),
      });
    }
  };

  const handleRemoveAllWords = useCallback(
    () =>
      onChange({
        ...params,
        words: [],
      }),
    [params]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <WordSearch onAdd={handleAddWord} words={words} />
      </Grid>
      <Grid item xs={12}>
        <MDBox display="flex" alignItems="center" flexWrap="wrap">
          {!!words.length && (
            <MDBox
              sx={{
                border: "1px solid silver",
                borderRadius: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                width: "100%",
              }}
            >
              <MDBox flex={1} p={1} sx={{ lineHeight: 2.4, maxHeight: 200, overflow: "auto" }}>
                {words.map((w) => (
                  <Chip key={w} label={w} onDelete={() => handleDeleteWord(w)} sx={{ mx: 0.5 }} />
                ))}
              </MDBox>
              <MDBox
                sx={(theme) => ({
                  p: 1,
                  borderLeft: "1px solid silver",
                  "&:hover": {
                    backgroundColor: "#ffffaa",
                    color: theme.palette.error.main,
                  },
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                })}
                onClick={handleRemoveAllWords}
              >
                <DeleteIcon sx={{ width: 24, height: 24 }} />
              </MDBox>
            </MDBox>
          )}
        </MDBox>
      </Grid>
    </Grid>
  );
}
Configurator.propTypes = {
  params: PropTypes.object,
  onChange: PropTypes.func,
};

export default Configurator;
